export const SUBMISSION_AUTOSAVE_PREFIX = 'submission_autosave';
